import * as React from 'react';

import { ActivityIndicator } from '~/src/atomic/atm.activity-indicator';

import { LoadingCenteredStyled } from './loading.component.style';

export const LoadingCentered = () => {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldRender(true);
    }, 1000);

    return clearTimeout(timeout);
  }, []);

  return shouldRender ? (
    <LoadingCenteredStyled>
      <ActivityIndicator type="spinner" />
    </LoadingCenteredStyled>
  ) : null;
};
